import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { trackEvent } from '../../analytics'

export function CTASection() {
  return (
    <section className="section-pad px-4 sm:px-6 lg:px-8 relative overflow-hidden bg-gradient-to-br from-primary to-primary-light dark:from-primary dark:to-navy-800">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_50%_at_50%_50%,rgba(255,215,0,0.08),transparent)] pointer-events-none" />
      <motion.div
        className="container-narrow text-center relative"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold font-display text-white mb-4 sm:mb-6">
          Let's Build Your Growth System
        </h2>
        <p className="text-slate-200 text-base sm:text-lg mb-6 sm:mb-8">
          If your business is ready to move from unpredictable marketing to structured growth, we would love to work with you.
        </p>
        <p className="text-slate-300 text-sm sm:text-base mb-8 sm:mb-10">
          Book a strategy discussion and let's explore how the BLS Method can help your business scale.
        </p>
        <motion.div whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.98 }}>
          <Link to="/contact" className="btn-primary bg-accent text-navy-900 hover:bg-accent-dark relative overflow-hidden group inline-block" onClick={() => trackEvent('cta_click', { cta_name: 'book_strategy_call', from: 'cta_section' })}>
            <span className="relative z-10">Book Strategy Call</span>
            <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/25 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-600" aria-hidden />
          </Link>
        </motion.div>
      </motion.div>
    </section>
  )
}
